<template>
  <div>
    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">待审批</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" v-for="(item,index) in list" :key="index" style="padding-left: 30px;">
          <gameTransactionBackview :itemData="item" :key="i"></gameTransactionBackview>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">产品发布审批</span>
        </el-col>
      </el-row>
      <el-table :data="auditList" style="margin-top: 15px">
        <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
        <el-table-column label="审批等级" align="center">一级部门</el-table-column>
        <el-table-column label="审批意见" align="center">同意</el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
        <el-table-column prop="createTime" label="更新日期" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审批状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditStatus === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 1" type="success" size="small">通过</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 2" type="danger" size="small">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template>
            <el-button type="text" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">退费订单审批</span>
        </el-col>
      </el-row>
      <el-empty description="暂无审批内容，休息一下吧～" :image-size="80"></el-empty>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">合同审批</span>
        </el-col>
      </el-row>
      <el-empty description="暂无审批内容，休息一下吧～" :image-size="80"></el-empty>
    </el-card>
  </div>
</template>
<script>
export default {
  data () {
    return {
      auditList: [
        { productName: '2026～2027赛季SPBCN个人赛赛程信息', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ],
      list: [
        {
          icon: 'icon-cuoqingdengji',
          title: '产品发布审批',
          flag: 'product_management1',
          menuTag: '8',
          number: 2
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '退费订单审批',
          flag: 'product_management1',
          menuTag: '4',
          number: 1
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '合同审批',
          flag: 'product_management1',
          menuTag: '5',
          number: 1
        },
        {
          icon: 'icon-cuoqingdengji',
          title: '超时流程',
          flag: 'product_management1',
          menuTag: '6',
          number: 0
        }
      ]
    }
  }
}
</script>
<style lang="less" scoped></style>
